function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import React from "react";
export var IconFacebook = function IconFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "55",
    height: "104",
    viewBox: "0 0 55 104",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M52 36.3728H33.25V23.8728C33.2546 22.2178 33.915 20.6321 35.0865 19.4631C36.2579 18.2941 37.845 17.637 39.5 17.6359H45.75V2H33.25C28.2772 2 23.5081 3.97544 19.9918 7.49175C16.4755 11.0081 14.5 15.7772 14.5 20.75V36.3859H2V52.0217H14.5V102H33.25V52H45.75L52 36.3728Z",
    stroke: "currentColor",
    strokeWidth: "3"
  }));
};